import React, { FC, useRef } from 'react'

import Component from '.'
import { Blok } from '@app/typings/blok'
import { useCloseOverlaysOnRouteChange } from '@app/hooks/use-close-overlays-on-route-change'
import { useHeadingNavigation } from '@izettle/public-site-components/dist/help-center'

type Props = {
  body: Blok[]
}

export const Article: FC<Props> = (props) => {
  useCloseOverlaysOnRouteChange()
  const rootElemRef = useRef<HTMLDivElement>(null)
  useHeadingNavigation({ rootElement: rootElemRef, selector: 'h2' })
  return (
    <div className="help-centre-article-body" ref={rootElemRef}>
      {props.body &&
        props.body.map((content, index) => {
          const title = (props as Props & { title?: string }).title
          const componentLayout = (content as any)?.layout?.[0]
          const layout = [{
            disableWrapperClass: true,
            disableMaximumWidth: true,
            overrideSectionPadding: true,
            ...componentLayout
          }]

          if (index === 0) {
            return (
              <div className="first-article-body-component">
                <Component key={content._uid} content={{title, ...content, layout}} />
              </div>
            )
          }
          return (
            <Component key={content._uid} content={{title, ...content, layout}} />
          )})}
    </div>
  )
}
